import { __decorate, __metadata } from 'tslib';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, Injectable, ɵɵdefineInjectable, forwardRef, ChangeDetectorRef, ChangeDetectionStrategy, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { trigger, state, style, transition, animate } from '@angular/animations';

let UtilsComponent = class UtilsComponent {
    constructor() {
        /** empty block */
    }
    ngOnInit() {
        /** empty bloack */
    }
};
UtilsComponent = __decorate([
    Component({
        selector: 'lib-utils',
        template: `
    <p>
      utils works!
    </p>
  `
    }),
    __metadata("design:paramtypes", [])
], UtilsComponent);

let PhoenixGridComponent = class PhoenixGridComponent {
    constructor() {
        this.showFilter = false;
        this.saveGridSettingsEvent = new EventEmitter();
        this.stateSaveEvent = new EventEmitter();
        this.selectAllCheckBoxEvent = new EventEmitter();
        this.singleCheckBoxSelectEvent = new EventEmitter();
    }
    stateSave(event) {
        this.stateSaveEvent.emit(event);
    }
    SelectAllCheckBox() {
        this.selectAllCheckBoxEvent.emit();
    }
    SingleCheckBoxSelect() {
        this.singleCheckBoxSelectEvent.emit();
    }
    saveGridSettings() {
        this.saveGridSettingsEvent.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Array)
], PhoenixGridComponent.prototype, "data", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], PhoenixGridComponent.prototype, "columns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], PhoenixGridComponent.prototype, "rowsPerPageArray", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridComponent.prototype, "tableState", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PhoenixGridComponent.prototype, "stateKey", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridComponent.prototype, "showFilter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowReorderingOfColumns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowResizingOfColumns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowSingleColumnSorting", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowPaginator", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowScroll", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], PhoenixGridComponent.prototype, "allowSelection", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridComponent.prototype, "saveGridSettingsEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridComponent.prototype, "stateSaveEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridComponent.prototype, "selectAllCheckBoxEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridComponent.prototype, "singleCheckBoxSelectEvent", void 0);
PhoenixGridComponent = __decorate([
    Component({
        selector: 'lib-phoenix-child-grid',
        template: "<p-table\r\n  #dt\r\n  [columns]=\"columns\"\r\n  [value]=\"data\"\r\n  [paginator]=\"allowPaginator\"\r\n  [reorderableColumns]=\"allowReorderingOfColumns\"\r\n  [resizableColumns]=\"allowResizingOfColumns\"\r\n  stateStorage=\"local\"\r\n  stateKey=\"{{ stateKey }}\"\r\n  [rowsPerPageOptions]=\"rowsPerPageArray\"\r\n  [scrollable]=\"allowScroll\"\r\n  styleClass=\"gridTableHeaderBorder\"\r\n  (onStateSave)=\"stateSave($event)\"\r\n>\r\n  <!-- primeng required to allow scroll -->\r\n  <ng-template pTemplate=\"colgroup\" let-columns>\r\n    <colgroup>\r\n      <col />\r\n      <col *ngFor=\"let col of columns\" style=\"width: 250px;\" />\r\n    </colgroup>\r\n  </ng-template>\r\n\r\n  <!--Header-->\r\n  <ng-template pTemplate=\"header\" let-columns>\r\n    <tr class=\"left\">\r\n      <ng-container *ngIf=\"allowSingleColumnSorting === true\">\r\n        <th class=\"width-3em\" *ngIf=\"allowSelection === true\" pResizableColumn>\r\n          <p-tableHeaderCheckbox\r\n            id=\"tableHeaderCheckbox\"\r\n            (click)=\"SelectAllCheckBox()\"\r\n          ></p-tableHeaderCheckbox>\r\n        </th>\r\n        <th\r\n          *ngFor=\"let col of columns\"\r\n          pReorderableColumn\r\n          [pSortableColumn]=\"col.field\"\r\n          pResizableColumn\r\n        >\r\n          {{ col.header }}\r\n        </th>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"allowSingleColumnSorting === false\">\r\n        <th *ngFor=\"let col of columns\" pReorderableColumn pResizableColumn>\r\n          {{ col.header }}\r\n        </th>\r\n      </ng-container>\r\n    </tr>\r\n    <!--Filters-->\r\n    <tr *ngIf=\"showFilter\" id=\"filteringOptionsRow\">\r\n      <th class=\"width-3em\" *ngIf=\"allowSelection\"></th>\r\n      <th *ngFor=\"let col of columns\" [ngSwitch]=\"col.field\">\r\n        <div *ngIf=\"col.type !== 'date'\">\r\n          <i class=\"pi pi-filter\" class=\"margin-right-0.5em\"></i>\r\n          <input\r\n            *ngSwitchCase=\"col.field\"\r\n            pInputText\r\n            type=\"{{ col.type }}\"\r\n            placeholder=\"Filter By {{ col.header }}\"\r\n            (input)=\"\r\n              dt.filter($event.target.value, col.field, col.filterMatchMode)\r\n            \"\r\n          />\r\n        </div>\r\n        <div *ngIf=\"col.type === 'date'\">\r\n          <p-calendar\r\n            placeholder=\"Filter By {{ col.header }} range\"\r\n            [(ngModel)]=\"rangeDates\"\r\n            [showIcon]=\"true\"\r\n            appendTo=\"body\"\r\n            dateFormat=\"yy-mm-dd\"\r\n            [showButtonBar]=\"true\"\r\n            [showOtherMonths]=\"false\"\r\n            (onSelect)=\"dt.filter($event.value, col.field, 'dateRangeFilter')\"\r\n            [monthNavigator]=\"true\"\r\n            [yearNavigator]=\"true\"\r\n            yearRange=\"1980:2030\"\r\n            selectionMode=\"range\"\r\n            [readonlyInput]=\"true\"\r\n          >\r\n          </p-calendar>\r\n        </div>\r\n      </th>\r\n    </tr>\r\n  </ng-template>\r\n\r\n  <!--Row-->\r\n  <ng-template pTemplate=\"body\" let-rowData let-columns=\"columns\">\r\n    <tr id=\"AllowSelectionCheckBoxBodyTrue\">\r\n      <td class=\"width-3em\" *ngIf=\"allowSelection\">\r\n        <p-tableCheckbox\r\n          id=\"tableBodyCheckbox\"\r\n          [value]=\"rowData\"\r\n          (click)=\"SingleCheckBoxSelect()\"\r\n        ></p-tableCheckbox>\r\n      </td>\r\n      <ng-container *ngFor=\"let col of columns\">\r\n        <td *ngIf=\"col.link; else noLink\">\r\n          <a\r\n            [innerHTML]=\"\r\n              col.formatter ? col.formatter(rowData) : rowData[col.field]\r\n            \"\r\n            routerLink=\"{{ col.link ? col.link(rowData) : rowData[col.field] }}\"\r\n          >\r\n          </a>\r\n        </td>\r\n        <ng-template #noLink>\r\n          <td\r\n            [innerHTML]=\"\r\n              col.formatter ? col.formatter(rowData) : rowData[col.field]\r\n            \"\r\n          ></td>\r\n        </ng-template>\r\n      </ng-container>\r\n    </tr>\r\n  </ng-template>\r\n</p-table>\r\n",
        styles: [""]
    })
], PhoenixGridComponent);

let GridService = class GridService {
    setGridStorage(stateKey, rowsPerPageArray) {
        const localStorageStateForThisStateKey = this.getDataFromLocalStorage(stateKey);
        const dataForStorage = Object.assign({}, localStorageStateForThisStateKey, {
            first: 0,
            rows: rowsPerPageArray[0],
            selection: [],
        });
        this.setLocalStorage(stateKey, dataForStorage);
    }
    updateLocalStorageToReflectColumnChanges(stateKey, selectedColumns) {
        const currentListOfSelectedColumns = selectedColumns.map((columns) => columns.field);
        const localStorageStateForThisStateKey = this.getDataFromLocalStorage(stateKey);
        const dataForStorage = Object.assign({}, localStorageStateForThisStateKey, {
            columnOrder: currentListOfSelectedColumns,
        });
        this.setLocalStorage(stateKey, dataForStorage);
    }
    setLocalStorage(stateKey, dataForStorage) {
        localStorage.setItem(stateKey, JSON.stringify(dataForStorage));
    }
    getDataFromLocalStorage(StateKey) {
        return JSON.parse(localStorage.getItem(StateKey));
    }
    getSelectionArrayFromLocalStorage(stateKey) {
        const localStorageStateForThisStateKey = this.getDataFromLocalStorage(stateKey);
        return localStorageStateForThisStateKey.selection;
    }
};
GridService = __decorate([
    Injectable()
], GridService);

let PhoenixGridContainerComponent = class PhoenixGridContainerComponent {
    constructor(gridService) {
        this.gridService = gridService;
        this.showFilter = false;
        this.allowReorderingOfColumns = false;
        this.allowResizingOfColumns = false;
        this.allowSingleColumnSorting = false;
        this.allowPaginator = false;
        this.allowScroll = false;
        this.allowSelection = false;
        this.stateSaveEvent = new EventEmitter();
        this.saveGridStateEvent = new EventEmitter();
        this.selectAllCheckBoxEvent = new EventEmitter();
        this.singleCheckBoxSelectEvent = new EventEmitter();
        this.selectedColumns = undefined;
    }
    set columns(value) {
        this.selectedColumns = value;
        this.handleColumnsChanged(this.selectedColumns);
    }
    ngOnInit() {
        this.gridService.setGridStorage(this.stateKey, this.rowsPerPageArray);
    }
    getSelectedDataFromStorage() {
        return this.gridService.getSelectionArrayFromLocalStorage(this.stateKey);
    }
    handleSaveGridSettings() {
        this.saveGridStateEvent.emit(this.stateKey);
    }
    handleColumnsChanged(selectedColumns) {
        if (this.stateKey) {
            this.gridService.updateLocalStorageToReflectColumnChanges(this.stateKey, selectedColumns);
        }
    }
    selectAllCheckBox() {
        this.selectAllCheckBoxEvent.emit({
            data: this.getSelectedDataFromStorage(),
        });
    }
    singleCheckBoxSelect() {
        this.singleCheckBoxSelectEvent.emit({
            data: this.getSelectedDataFromStorage(),
        });
    }
};
PhoenixGridContainerComponent.ctorParameters = () => [
    { type: GridService }
];
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PhoenixGridContainerComponent.prototype, "columns", null);
__decorate([
    Input(),
    __metadata("design:type", Observable)
], PhoenixGridContainerComponent.prototype, "data$", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "showFilter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], PhoenixGridContainerComponent.prototype, "rowsPerPageArray", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PhoenixGridContainerComponent.prototype, "stateKey", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowReorderingOfColumns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowResizingOfColumns", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowSingleColumnSorting", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowPaginator", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowScroll", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], PhoenixGridContainerComponent.prototype, "allowSelection", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridContainerComponent.prototype, "stateSaveEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridContainerComponent.prototype, "saveGridStateEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridContainerComponent.prototype, "selectAllCheckBoxEvent", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PhoenixGridContainerComponent.prototype, "singleCheckBoxSelectEvent", void 0);
PhoenixGridContainerComponent = __decorate([
    Component({
        selector: 'lib-phoenix-grid',
        template: "<lib-phoenix-child-grid\r\n  [data]=\"data$ | async\"\r\n  [columns]=\"selectedColumns\"\r\n  [rowsPerPageArray]=\"rowsPerPageArray\"\r\n  [stateKey]=\"stateKey\"\r\n  [showFilter]=\"showFilter\"\r\n  [allowReorderingOfColumns]=\"allowReorderingOfColumns\"\r\n  [allowResizingOfColumns]=\"allowResizingOfColumns\"\r\n  [allowSingleColumnSorting]=\"allowSingleColumnSorting\"\r\n  [allowPaginator]=\"allowPaginator\"\r\n  [allowScroll]=\"allowScroll\"\r\n  [allowSelection]=\"allowSelection\"\r\n  (selectAllCheckBoxEvent)=\"selectAllCheckBox()\"\r\n  (singleCheckBoxSelectEvent)=\"singleCheckBoxSelect()\"\r\n  (saveGridSettingsEvent)=\"handleSaveGridSettings()\"\r\n>\r\n</lib-phoenix-child-grid>\r\n",
        providers: [GridService],
        styles: [""]
    }),
    __metadata("design:paramtypes", [GridService])
], PhoenixGridContainerComponent);

let SpinnerService = class SpinnerService {
    constructor() {
        this.spinnerSubject = new BehaviorSubject({ show: false });
        this.spinnerState = this.spinnerSubject.asObservable();
        /** empty block */
    }
    /**
     * @deprecated since version .0.18. Must be replaced with on()
     * and will be removed in the next version
     */
    show() {
        //
    }
    /**
     * @deprecated since version .0.18. Must be replaced with off()
     * and will be removed in the next version
     */
    hide() {
        //
    }
    on() {
        this.spinnerSubject.next({ show: true });
    }
    off() {
        this.spinnerSubject.next({ show: false });
    }
};
SpinnerService.ɵprov = ɵɵdefineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
SpinnerService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [])
], SpinnerService);

let SpinnerComponent = class SpinnerComponent {
    constructor(spinnerService) {
        this.spinnerService = spinnerService;
        this.shouldSubscribe = true;
    }
    set visibleSetter(visible) {
        this.shouldSubscribe = false;
        this.visible = visible;
    }
    ngOnInit() {
        if (this.shouldSubscribe) {
            this.spinnerStateChanged = this.spinnerService.spinnerState.subscribe((state) => {
                this.visible = state.show;
            });
        }
    }
    ngOnDestroy() {
        if (this.shouldSubscribe) {
            this.spinnerStateChanged.unsubscribe();
        }
    }
};
SpinnerComponent.ctorParameters = () => [
    { type: SpinnerService }
];
__decorate([
    Input('visible'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], SpinnerComponent.prototype, "visibleSetter", null);
SpinnerComponent = __decorate([
    Component({
        selector: 'lib-working-spinner-component',
        template: "<div class=\"spinner-background\" *ngIf=\"visible\">\r\n  <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n</div>\r\n",
        styles: [":host ::ng-deep .custom-spinner{position:absolute;top:50%;left:50%;height:80px!important;width:80px!important;margin-top:-40px;margin-left:-40px;background:var(--white) 0 0 no-repeat padding-box;background:no-repeat padding-box #fff;border-radius:50px;box-shadow:0 3px 6px #00000029;opacity:1}:host ::ng-deep .ui-progress-spinner-svg{height:48px!important;width:48px!important}:host ::ng-deep .ui-progress-spinner .ui-progress-spinner-circle{stroke:#414141!important}.spinner-background{height:100%;width:100%;position:absolute;top:0;left:0;z-index:1;background-color:rgba(0,0,0,.04)}"]
    }),
    __metadata("design:paramtypes", [SpinnerService])
], SpinnerComponent);

class Message {
    constructor(id, content, size, style) {
        this.id = id;
        this.content = content;
        this.size = size;
        this.style = style;
    }
}
var MessageType;
(function (MessageType) {
    MessageType[MessageType["Success"] = 0] = "Success";
    MessageType[MessageType["Error"] = 1] = "Error";
    MessageType[MessageType["Warning"] = 2] = "Warning";
})(MessageType || (MessageType = {}));
var MessageSize;
(function (MessageSize) {
    MessageSize[MessageSize["Small"] = 0] = "Small";
    MessageSize[MessageSize["Med"] = 1] = "Med";
})(MessageSize || (MessageSize = {}));

let SuccessMessageService = class SuccessMessageService {
    constructor() {
        this.message$ = new Subject();
    }
    success(id, content) {
        this.message$.next(new Message(id, content, MessageSize.Med, MessageType.Success));
    }
    error(id, content) {
        this.message$.next(new Message(id, content, MessageSize.Med, MessageType.Error));
    }
    warning(id, content) {
        this.message$.next(new Message(id, content, MessageSize.Med, MessageType.Warning));
    }
    getMessage() {
        return this.message$.asObservable();
    }
};
SuccessMessageService.ɵprov = ɵɵdefineInjectable({ factory: function SuccessMessageService_Factory() { return new SuccessMessageService(); }, token: SuccessMessageService, providedIn: "root" });
SuccessMessageService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [])
], SuccessMessageService);

let SuccessMessageComponent = class SuccessMessageComponent {
    constructor(messageService) {
        this.messageService = messageService;
        this.showList = false;
        this.floating = false;
        this.messages = [];
        this.timeoutLength = 15000;
    }
    ngOnInit() {
        this.messageSubscription = this.messageService
            .getMessage()
            .subscribe((msg) => {
            if (msg.id === this.id) {
                if (this.showList) {
                    this.messages.push(msg);
                    this.removeMessageTimed(msg);
                }
                else {
                    this.messages[0] = msg;
                    this.removeMessageTimed(msg);
                }
            }
        });
    }
    removeMessageTimed(msg) {
        setTimeout(() => (this.messages = this.messages.filter((m) => m !== msg)), this.timeoutLength);
    }
    removeMessage(msg) {
        this.messages = this.messages.filter((m) => m !== msg);
    }
    getTextStyle(msg) {
        switch (msg.style) {
            case MessageType.Success:
                return 'msg-success';
            case MessageType.Error:
                return 'msg-error';
            case MessageType.Warning:
                return 'msg-warning';
            default:
                return 'msg-error';
        }
    }
    containerStyle() {
        return this.floating ? 'msg-container-floating' : 'msg-container';
    }
    getImagePath(msg) {
        switch (msg.style) {
            case MessageType.Success:
                return './assets/images/success_icon.png';
            case MessageType.Error:
                return './assets/images/failed_icon.png';
            case MessageType.Warning:
                return './assets/images/warning_icon.png';
            default:
                return './assets/images/failed_icon.png';
        }
    }
    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
    }
};
SuccessMessageComponent.ctorParameters = () => [
    { type: SuccessMessageService }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], SuccessMessageComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SuccessMessageComponent.prototype, "showList", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SuccessMessageComponent.prototype, "floating", void 0);
SuccessMessageComponent = __decorate([
    Component({
        selector: 'lib-success-message',
        template: "<div class=\"{{containerStyle()}}\">\r\n  <ng-container *ngFor=\"let msg of messages\">\r\n      <div> <!-- removes ng-star-inserted in css class -->\r\n          <div class=\"msg\">\r\n              <img class=\"msg-image\" src=\"{{getImagePath(msg)}}\"/> \r\n              <div class=\"{{getTextStyle(msg)}}\">\r\n                {{msg.content}}\r\n              </div>\r\n              <img class=\"msg-close-image\" src=\"assets/images/close_icon.png\" (click)=\"removeMessage(msg)\" />\r\n          </div>\r\n      </div>\r\n  </ng-container>\r\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [SuccessMessageService])
], SuccessMessageComponent);

let ValidationService = class ValidationService {
    // get the appropriate error message
    getErrorMessage(validatorName, validatorValue, customMsg = () => '') {
        const cm = customMsg({ validatorName, validatorValue });
        const config = {
            required: cm === '' ? 'Required' : cm,
            pattern: cm === '' ? 'Failed Pattern Match' : cm,
            minlength: cm === ''
                ? `Minimum length ${validatorValue ? ` of ${validatorValue.requiredLength}` : ''} is required`
                : cm,
            maxlength: cm === ''
                ? `Maximum length ${validatorValue ? ` of ${validatorValue.requiredLength}` : ''} is required`
                : cm,
            mustMatch: cm === '' ? 'Must match' : cm,
            email: cm === '' ? 'Must be an email address' : cm,
            invalidPhoneNumber: cm === '' ? 'Please enter a valid phone number' : cm,
            invalidWelcomeMessage: cm === '' ? `Maximum 100 Characters allowed` : cm,
            invalidWelcomeNews: cm === '' ? `Maximum 500 Characters allowed` : cm,
        };
        return config[validatorName];
    }
    /** function to validate whether 2 fields are equal or not */
    MustMatch(controlName, matchingControlName) {
        return (formGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({ mustMatch: true });
            }
            else {
                matchingControl.setErrors(null);
            }
        };
    }
    /** function to validate patterns */
    patternValidator(fieldName) {
        return (control) => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }
            // test the value of the control against the regexps
            let valid;
            let error;
            switch (fieldName) {
                case 'number':
                    valid = /[0-9]+/.test(control.value);
                    error = { hasNumber: true };
                    break;
                case 'upperCase':
                    valid = /[A-Z]+/.test(control.value);
                    error = { hasCapitalCase: true };
                    break;
                case 'lowerCase':
                    valid = /[a-z]+/.test(control.value);
                    error = { hasSmallCase: true };
                    break;
            }
            // if true, return no error (no error), else return error
            return valid ? null : error;
        };
    }
    /* Custom function to validate whether field value meet min length condition as passed by value param */
    minimumLength(value) {
        return (control) => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }
            const valid = control.value.length < value ? false : true;
            // if true, return null (no error), else return error
            return valid
                ? null
                : {
                    hasMinLength: true,
                };
        };
    }
    /** Function to validate whether the field has at least one special character */
    specialCharacterValidator() {
        return (control) => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }
            // test the value of the control against the regexp
            const regexp = /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\,\~\`\?\\_\-\/\\]/g;
            const symbols = regexp.test(control.value);
            const valid = symbols === true ? true : false;
            // if true, return null (no error), else return error
            return valid
                ? null
                : {
                    hasSpecialCharacters: true,
                };
        };
    }
    /** Function to validate whether the field does not contain all spaces */
    noWhitespaceValidator() {
        return (control) => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }
            const isWhitespace = ((control && control.value && control.value.toString()) || '').trim()
                .length === 0;
            const isValid = !isWhitespace;
            return isValid ? null : { required: true };
        };
    }
    validatePhoneForm(phoneNumberControlName, ExtensionControlName) {
        return (formGroup) => {
            const phoneNumberControl = formGroup.controls[phoneNumberControlName];
            const extensionControl = formGroup.controls[ExtensionControlName];
            try {
                return extensionControl &&
                    extensionControl.value &&
                    extensionControl.value.length > 0 &&
                    phoneNumberControl.value.length === 0
                    ? { invalidPhoneNumber: true }
                    : null;
            }
            catch (error) {
                return error;
            }
        };
    }
    validatePhoneNumber(parser) {
        return (control) => {
            try {
                const phoneNumber = parser(control.value.toString());
                return phoneNumber.isValid()
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (_a) {
                return control && control.value && control.value.length < 1
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
        };
    }
};
ValidationService.ɵprov = ɵɵdefineInjectable({ factory: function ValidationService_Factory() { return new ValidationService(); }, token: ValidationService, providedIn: "root" });
ValidationService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ValidationService);

let ControlMessageComponent = class ControlMessageComponent {
    constructor(validationService) {
        this.validationService = validationService;
    }
    // grabs the appropriate error message, uses a heirachy from the service so it only display most relevant error
    // could display all if we want
    get errorMessage() {
        if (this.control) {
            for (const propertyName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
                    return this.validationService.getErrorMessage(propertyName, this.control.errors[propertyName], this.errorMsg);
                }
            }
            return null;
        }
        return null;
    }
};
ControlMessageComponent.ctorParameters = () => [
    { type: ValidationService }
];
__decorate([
    Input(),
    __metadata("design:type", FormControl)
], ControlMessageComponent.prototype, "control", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], ControlMessageComponent.prototype, "errorMsg", void 0);
ControlMessageComponent = __decorate([
    Component({
        selector: 'lib-control-message',
        template: "<div class=\"error\" *ngIf=\"errorMessage != null\">{{errorMessage}}</div>\r\n",
        styles: [".error{color:#e91224}"]
    }),
    __metadata("design:paramtypes", [ValidationService])
], ControlMessageComponent);

let PasswordValidationComponent = class PasswordValidationComponent {
    constructor() {
        this.hasPassword = new EventEmitter();
        this.passwordError = false;
        this.minLengthCheck = false;
        this.upperCaseCheck = false;
        this.lowerCaseCheck = false;
        this.numberCheck = false;
        this.symbolCheck = false;
    }
    checkStrength(p) {
        const regex = /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\,\~\`\?\\_\-\/\\]/g;
        const lowerLetters = /[a-z]+/.test(p);
        const upperLetters = /[A-Z]+/.test(p);
        const numbers = /[0-9]+/.test(p);
        const symbols = regex.test(p);
        // short password
        this.minLengthCheck = p.length < 8 ? true : false;
        // Lower case
        this.lowerCaseCheck = lowerLetters === true ? false : true;
        // upper case
        this.upperCaseCheck = upperLetters === true ? false : true;
        // number check
        this.numberCheck = numbers === true ? false : true;
        // special character
        this.symbolCheck = symbols === true ? false : true;
    }
    ngOnChanges(changes) {
        const password = changes.passwordToCheck.currentValue;
        if (password) {
            this.passwordError = true;
            this.checkStrength(password);
        }
        else {
            this.passwordError = false;
        }
        this.hasPassword.emit(this.passwordError);
    }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], PasswordValidationComponent.prototype, "passwordToCheck", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PasswordValidationComponent.prototype, "hasPassword", void 0);
PasswordValidationComponent = __decorate([
    Component({
        selector: 'lib-password-validation',
        template: "<div *ngIf=\"passwordError\">\r\n  <ul class=\"no-padding-left fontSize12px listStyleNone no-margin-bottom\">\r\n    <li\r\n      [ngClass]=\"{\r\n        'successTextColor fontWeightSemiBold': minLengthCheck === false,\r\n        mediumDarkGreyColor: minLengthCheck === true\r\n      }\"\r\n    >\r\n      {{ \"COMMON.STRONG_PASSWORD_MINLENGTH_HINT\" | transloco }}\r\n    </li>\r\n    <li\r\n      [ngClass]=\"{\r\n        'successTextColor fontWeightSemiBold':\r\n          numberCheck === false && symbolCheck === false,\r\n        mediumDarkGreyColor: numberCheck === true || symbolCheck === true\r\n      }\"\r\n    >\r\n      {{ \"COMMON.STRONG_PASSWORD_NUMBER_SYMBOL_HINT\" | transloco }}\r\n    </li>\r\n    <li\r\n      [ngClass]=\"{\r\n        'successTextColor fontWeightSemiBold':\r\n          upperCaseCheck === false && lowerCaseCheck === false,\r\n        mediumDarkGreyColor: upperCaseCheck === true || lowerCaseCheck === true\r\n      }\"\r\n    >\r\n      {{ \"COMMON.STRONG_PASSWORD_LETTER_HINT\" | transloco }}\r\n    </li>\r\n  </ul>\r\n  <br />\r\n</div>\r\n",
        styles: [""]
    })
], PasswordValidationComponent);

const LOADINGBUTTON_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => LoadingButtonComponent),
    multi: true,
};
const buttonTrigger = trigger('buttonTrigger', [
    state('enabled', style({
        pointerEvents: 'auto',
        backgroundColor: 'green',
        width: '7rem',
        height: '2rem',
        cursor: 'pointer',
        lineHeight: '1.9rem',
        border: '0.1rem solid black',
    })),
    state('notEnabled', style({
        pointerEvents: 'auto',
        backgroundColor: 'red',
        width: '7rem',
        height: '2rem',
        lineHeight: '1.9rem',
        border: '0.1rem solid black',
    })),
    state('loading', style({
        pointerEvents: 'none',
        borderRadius: '0.2rem',
        backgroundColor: 'rgb(255, 190, 50)',
        opacity: '0.8',
        paddingBottom: '1rem',
        border: 'none',
    })),
    state('success', style({
        pointerEvents: 'none',
        backgroundColor: 'rgb(255, 190, 50)',
    })),
    state('failure', style({
        pointerEvents: 'none',
        backgroundColor: 'rgb(255, 190, 50)',
    })),
    transition('enabled => loading', [animate('0.2s')]),
    transition('notEnabled => loading', [animate('0.2s')]),
    transition('* => success', [animate('0.4s')]),
    transition('* => failure', [animate('0.4s')]),
    transition('* => enabled', [animate('0.2s')]),
    transition('* => notEnabled', [animate('0.2s')]),
]);
const buttonSpanTrigger = trigger('buttonSpanTrigger', [
    state('clickable', style({
        pointerEvents: 'auto',
        opacity: 1,
        position: 'relative',
    })),
    state('notclickable', style({
        pointerEvents: 'none',
        opacity: 0,
        position: 'relative',
    })),
    state('postload', style({
        pointerEvents: 'none',
        opacity: 1,
        top: '0px',
        position: 'relative',
    })),
]);
let LoadingButtonComponent = class LoadingButtonComponent {
    /*
    public postAnimation(event: Event) {
      console.log('postanim');
          if (this.currentState === 'success' || this.currentState === 'failure') {
        this.handleStateSwitch();
      }
    }
    */
    constructor(cd) {
        this.cd = cd;
        // Deprecated: no longer useful
        this.successMessage = '✔';
        // Deprecated: no longer useful
        this.failureMessage = '✖';
        // Disable the button so it cannot be clicked
        this.disabled = false;
        // The time before a requested is deemed to have been timed out and cause the button
        // to consider it a failed request.
        this.timeout = 10000;
        // When clicked on in an interactive state, the component will run this function
        // tslint:disable-next-line: no-output-on-prefix
        this.onChange = new EventEmitter();
        this.enabledMessage = 'Enabled';
        this.disabledMessage = 'Disabled';
        // Implementing ControlValueAccessor
        // tslint:disable-next-line: no-empty
        this.onModelChange = () => { };
        // tslint:disable-next-line: no-empty
        this.onModelTouched = () => { };
        // set the button to off by default
        this.currentState = 'notEnabled';
        this.initialState = false;
        this.message = this.disabledMessage;
    }
    // LBMX Loading button component
    /*=
     *  Cam Della-Savia, February 2022. Notes:
     *=
     *  The purpose of this component was to create something similar to PrimeNG's
     *  toggle button, but have an intermediate state where the button would exist in
     *  while the request it sent was pending. The button will only toggle when the response
     *  input CHANGES.
     *=
     *  Another reason for designing this component was to change the colors of the
     *  button without getting complex css involved. Sadly, it is impossible to set
     *  the colors of the button dynamically, as angular animation does not allow for that.
     *=
     *  Lastly, there were originally 5 states involved with this button. Enabled/disabled,
     *  loading, and success/failure. The latter two states described if the request was successful
     *  or not when returned. Because of the way Angular's lifecycle works, success/failure was scraped
     *  as it threw an ExpressionChangedAfterItHasBeenCheckedError in the console when the state changed
     *  post animation. The success and failure states were also deemed unnecessary and ultimately confusing
     *  to a user. They are still implemented, but are not seen due to ngAfterContentChecked taking
     *  precedent over postAnimaton. postAnimation was used before to determine whether a state change
     *  was necessary
     *=
     *  USAGE:
     *  Declare the function the toggle should run into onChange (output)
     *  Declare the response to be read by toggle in response (input)
     *  Declare which formcontrol the button binds to with formControlName=""
     *=
     *  This button is untested with an actual react form. The point was for this button to immediately submit given information.
     *  I should probably remove the form control accessor and replace it with an initialstate input
     */
    // Component inputs
    // USE formControlName="" TO SET AN INITIAL STATE, AS CONTROLVALUEACCESSOR
    // IS IMPLEMENTED (PrimeNG)
    // Response: an object with a success flag and a message.
    set responseSetter(parentResponse) {
        if (parentResponse && parentResponse.success) {
            this.isSuccessful = true;
        }
        else {
            this.isSuccessful = false;
        }
        if (this.responseTimeout) {
            clearTimeout(this.responseTimeout);
        }
        this.handleStateSwitch();
    }
    // Message to be displayed when the button is toggled
    set enabledMessageSetter(parentBind) {
        if (parentBind) {
            this.enabledMessage = parentBind;
        }
    }
    // Message to be displayed when the button is not toggled
    set disabledMessageSetter(parentBind) {
        if (parentBind) {
            this.disabledMessage = parentBind;
        }
    }
    ngAfterContentChecked() {
        if (this.currentState === 'success' || this.currentState === 'failure') {
            this.handleStateSwitch();
        }
    }
    setMessage() {
        if (this.currentState === 'enabled') {
            this.message = this.enabledMessage;
        }
        else if (this.currentState === 'notEnabled') {
            this.message = this.disabledMessage;
        }
        else if (this.currentState === 'success') {
            this.message = this.successMessage;
        }
        else if (this.currentState === 'failure') {
            this.message = this.failureMessage;
        }
    }
    getButtonSpanState() {
        if (this.currentState === 'enabled' || this.currentState === 'notEnabled') {
            return 'clickable';
        }
        else if (this.currentState === 'loading') {
            return 'notclickable';
        }
        else {
            return 'postload';
        }
    }
    handleClick(event) {
        if (this.disabled) {
            return;
        }
        // Interactive states
        if (this.currentState === 'enabled' || this.currentState === 'notEnabled') {
            // The request timeout is described here
            this.responseTimeout = setTimeout(() => {
                this.isSuccessful = false;
                this.handleStateSwitch();
                this.cd.markForCheck();
            }, this.timeout);
            // Core functionality
            this.onChange.emit({
                originalEvent: event,
                buttonState: this.currentState,
                desiredState: this.getDesiredState(),
            });
            this.handleStateSwitch();
        }
    }
    handleStateSwitch() {
        switch (this.currentState) {
            case 'enabled':
                this.currentState = 'loading';
                break;
            case 'notEnabled':
                this.currentState = 'loading';
                break;
            case 'success':
                // The button successfully updated
                if (this.initialState) {
                    this.currentState = 'notEnabled';
                    this.initialState = false;
                }
                else {
                    this.currentState = 'enabled';
                    this.initialState = true;
                }
                break;
            case 'failure':
                // The button failed to update
                if (this.initialState) {
                    this.currentState = 'enabled';
                    this.initialState = true;
                }
                else {
                    this.currentState = 'notEnabled';
                    this.initialState = false;
                }
                break;
            // loading
            default:
                if (this.isSuccessful) {
                    this.currentState = 'success';
                }
                else {
                    this.currentState = 'failure';
                }
                break;
        }
        this.setMessage();
    }
    getDesiredState() {
        if (this.currentState === 'enabled') {
            return false;
        }
        else {
            return true;
        }
    }
    // This function runs on when it is fed a control value. Used to set the
    // initial state of the toggle passed on a control
    writeValue(value) {
        this.initialState = value;
        if (this.initialState) {
            this.currentState = 'enabled';
        }
        else {
            this.currentState = 'notEnabled';
        }
        this.setMessage();
    }
    registerOnChange(fn) {
        this.onModelChange = fn;
    }
    registerOnTouched(fn) {
        this.onModelTouched = fn;
    }
    setDisabledState(val) {
        this.disabled = val;
        this.cd.markForCheck();
    }
};
LoadingButtonComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input('response'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], LoadingButtonComponent.prototype, "responseSetter", null);
__decorate([
    Input('enabledMessage'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LoadingButtonComponent.prototype, "enabledMessageSetter", null);
__decorate([
    Input('disabledMessage'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], LoadingButtonComponent.prototype, "disabledMessageSetter", null);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LoadingButtonComponent.prototype, "successMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LoadingButtonComponent.prototype, "failureMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LoadingButtonComponent.prototype, "style", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], LoadingButtonComponent.prototype, "styleClass", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LoadingButtonComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], LoadingButtonComponent.prototype, "timeout", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], LoadingButtonComponent.prototype, "onChange", void 0);
LoadingButtonComponent = __decorate([
    Component({
        selector: 'lib-loading-button',
        template: "<div\r\n  class=\"loading-button [ngStyle]='style' [class]='styleClass'\"\r\n  (click)=\"handleClick($event)\"\r\n  [@buttonTrigger]=\"currentState\"\r\n  [ngClass]=\"currentState\"\r\n>\r\n  <span [@buttonSpanTrigger]=\"getButtonSpanState()\"> {{ message }}</span>\r\n</div>\r\n",
        providers: [LOADINGBUTTON_VALUE_ACCESSOR],
        changeDetection: ChangeDetectionStrategy.OnPush,
        animations: [buttonTrigger, buttonSpanTrigger],
        styles: [".loading-button{width:7rem;height:2rem;cursor:pointer;line-height:2rem;color:#fff;text-align:center;-webkit-user-select:none;-moz-user-select:none;user-select:none}@-webkit-keyframes loading-animation{0%{box-shadow:0 0 0 0 rgb(255,190,100,.8)}100%{box-shadow:0 0 0 1rem rgb(255,190,100,0)}}@keyframes loading-animation{0%{box-shadow:0 0 0 0 rgb(255,190,100,.8)}100%{box-shadow:0 0 0 1rem rgb(255,190,100,0)}}.loading-button.loading{pointer-events:none;-webkit-animation:4s 1s infinite loading-animation;animation:4s 1s infinite loading-animation}"]
    }),
    __metadata("design:paramtypes", [ChangeDetectorRef])
], LoadingButtonComponent);

let ToastrNotificationService = class ToastrNotificationService {
    constructor() {
        this.life = 3000;
        this.toasterSubject = new BehaviorSubject({});
        this.toasterState = this.toasterSubject.asObservable();
        /* Empty */
    }
    successNotify(message, title, life = this.life) {
        this.toasterSubject.next({
            severity: 'success',
            summary: title,
            detail: message,
            life,
        });
    }
    infoNotify(message, title, life = this.life) {
        this.toasterSubject.next({
            severity: 'info',
            summary: title,
            detail: message,
            life,
        });
    }
    warnNotify(message, title, life = this.life) {
        this.toasterSubject.next({
            severity: 'warn',
            summary: title,
            detail: message,
            life,
        });
    }
    errorNotify(message, title, life = this.life) {
        this.toasterSubject.next({
            severity: 'error',
            summary: title,
            detail: message,
            life,
        });
    }
};
ToastrNotificationService.ɵprov = ɵɵdefineInjectable({ factory: function ToastrNotificationService_Factory() { return new ToastrNotificationService(); }, token: ToastrNotificationService, providedIn: "root" });
ToastrNotificationService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [])
], ToastrNotificationService);

let ToastNotificationComponent = class ToastNotificationComponent {
    constructor(toastService, messageService) {
        this.toastService = toastService;
        this.messageService = messageService;
    }
    set visibleSetter(visible) {
        this.visible = visible;
    }
    ngOnInit() {
        this.toasterStateChanged = this.toastService.toasterState.subscribe((state) => {
            this.messageService.add({
                detail: state.detail,
                life: state.life,
                severity: state.severity,
                summary: state.summary,
            });
        });
    }
    ngOnDestroy() {
        this.toasterStateChanged.unsubscribe();
    }
};
ToastNotificationComponent.ctorParameters = () => [
    { type: ToastrNotificationService },
    { type: MessageService }
];
__decorate([
    Input('visible'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ToastNotificationComponent.prototype, "visibleSetter", null);
ToastNotificationComponent = __decorate([
    Component({
        selector: 'lib-toast-notification',
        template: "<p-toast position=\"top-center\" styleClass=\"user-notification\"></p-toast>\r\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [ToastrNotificationService,
        MessageService])
], ToastNotificationComponent);

let UtilsModule = class UtilsModule {
};
UtilsModule = __decorate([
    NgModule({
        declarations: [
            UtilsComponent,
            SpinnerComponent,
            ControlMessageComponent,
            PhoenixGridComponent,
            PhoenixGridContainerComponent,
            SuccessMessageComponent,
            PasswordValidationComponent,
            ToastNotificationComponent,
            LoadingButtonComponent,
        ],
        providers: [
            ToastrNotificationService,
            SpinnerService,
            ValidationService,
            MessageService,
            SuccessMessageService,
        ],
        imports: [
            FormsModule,
            CommonModule,
            ToastModule,
            ProgressSpinnerModule,
            ButtonModule,
            DropdownModule,
            InputTextModule,
            MultiSelectModule,
            DialogModule,
            CalendarModule,
            RouterModule,
            TableModule,
            TranslocoModule,
        ],
        exports: [
            UtilsComponent,
            SpinnerComponent,
            ToastNotificationComponent,
            ControlMessageComponent,
            PhoenixGridComponent,
            PhoenixGridContainerComponent,
            SuccessMessageComponent,
            PasswordValidationComponent,
            LoadingButtonComponent,
        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
    })
], UtilsModule);

let UtilsService = class UtilsService {
    constructor() {
        /** empty block */
    }
};
UtilsService.ɵprov = ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(); }, token: UtilsService, providedIn: "root" });
UtilsService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UtilsService);

/*
 * Public API Surface of utils
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ControlMessageComponent, GridService, LOADINGBUTTON_VALUE_ACCESSOR, LoadingButtonComponent, PhoenixGridComponent, PhoenixGridContainerComponent, SpinnerComponent, SpinnerService, SuccessMessageComponent, SuccessMessageService, ToastrNotificationService, UtilsComponent, UtilsModule, UtilsService, ValidationService, PasswordValidationComponent as ɵa, ToastNotificationComponent as ɵb };
//# sourceMappingURL=lbmx-phoenix-lib-utils.js.map
